import { useQuery } from '@tanstack/react-query';
import type { OrganizerPageData } from '@/api/services/organizer-profile-service';
import { withBasePath } from '@/utils/withBasePath';

const EDITOR_CONTEXT_QUERY_KEY = 'organizer-editor-context';

async function fetchFreshOrganizerContext(organizerId: string): Promise<OrganizerPageData | null> {
  try {
    const res = await fetch(withBasePath(`/api/organizers/${organizerId}/context`), {
      method: 'GET',
      cache: 'no-store',
      credentials: 'include',
    });
    if (!res.ok) return null;
    return (await res.json()) as OrganizerPageData;
  } catch {
    return null;
  }
}

interface UseEditorContextRefreshArgs {
  organizerId: string;
  enabled: boolean;
}

export function useEditorContextRefresh({ organizerId, enabled }: UseEditorContextRefreshArgs) {
  return useQuery<OrganizerPageData | null>({
    queryKey: [EDITOR_CONTEXT_QUERY_KEY, organizerId],
    queryFn: () => fetchFreshOrganizerContext(organizerId),
    enabled,
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
